import React from 'react';
import OpinionesWidget from "./OpinionesWidget";
import BALogo from "./BALogo";

const Opiniones = ({ type = "deportiva", title = "LAS MEJORES PAGINAS DE APUESTAS", ...rest }) => {

    return (
        <div>
            <div className="text-center title-text home-title first-title-separator home-title-container">
                <div className="ban-spain-img__pos">
                    <img className="ban-spain-img" src={require('./resources/ban-spain.png')} alt="España" />
                </div>
                <div className="home-main-title__pos">
                    {title}
                </div>                
            </div>

            <div className="options-headers-section">
                <div className="opinions-section__opinions opiniones-text">
                    <div className="opiniones-main-text">
                        <p>
                            Los principales casinos virtuales de España bajo la lupa de <span className="title-text-dark title-text-bold">bonosapuestas.com.</ span> Evaluamos sus bonos de bienvenida, seguridad, rapidez de los pagos, 
                            variedad de juegos, servicio de atencion al cliente, calidad de la web y mas.
                        </p>
                        <p>
                            Estas casa de juego y apuestas lo tienen todo. Encuentra tu casino ideal para divertirte de forma segura desde el confort de casa.
                        </p>
                    </div>
                    <div className="opiniones-text-bottom-grid">
                        <div className="opiniones-text-border opiniones-text-margin title-text-dark title-text-bold">
                            Sólo Páginas Legales
                        </div>
                        <div className="opiniones-text-border opiniones-text-margin title-text-dark title-text-bold">
                            Las Mejores Cuotas y Bonos de Bienvenida
                        </div>
                        <div className="opiniones-text-margin title-text-dark title-text-bold">
                            Pagos Garantizados
                        </div>                        
                    </div>
                </div>
                <div className="footer-copyright stamps-margin">
                    <img className="footer-img" src="assets/images/responsabilidad.png" />
                    <img className="footer-img" src="assets/images/juegoseguro.png" />
                    <img className="footer-img footer-img__jugarbien" src="assets/images/juegabien.png" />
                    <img className="footer-img footer-img__18plus" src="assets/images/18plus.png" />
                    <img className="footer-img footer-img__autopohibicion" src="assets/images/autoprohibicion.png" />
                </div>
            </div> 

            <div className="bg-circle bg-circle-opciones-pos">
                <BALogo height={"80%"} width={"80%"} primaryColor={"#FFFFFF"} />
            </div> 
            <div className="bonos-tiles-section">
                <OpinionesWidget startPoint={0} endPoint={6} type={type}/>
            </div>
            <div className="text-center title-text home-title main-title-separator">
                Otras Opiniones...
            </div>
            <div className="bonos-tiles-section otros-bonos-sec">
                <OpinionesWidget startPoint={6} endPoint={12} type={type}/>
            </div>
        </div >
    );
}

export default Opiniones;
